import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { Button, Spin, Icon, Col, Row, Alert, Modal } from "antd";

import Meter from "./components/meter/Meter";
import FiltrationTags from "./components/FiltrationTags";

import getAddressMeters from "../../store/thunks/getAddressMeters";
import saveNewMetersValues from "../../store/thunks/saveNewMetersValues";
import useParam from "../../../../hooks/useParam";
import actions from "../../store/actions/actions";

import "./AddressMeters.scss";
import useAddressFromParams from "../../hooks/useAddressFromParams";

const SaveButton = ({
	changedMeters,
	houseId,
	activeMeterTypes,
	meterCode,
	activeTags,
}) => {
	const dispatch = useDispatch();
	const { confirm } = Modal;
	const saveChanges = useCallback(async () => {
		await dispatch(saveNewMetersValues(changedMeters));
		dispatch(getAddressMeters(houseId, activeMeterTypes, meterCode, activeTags));
		dispatch({
			type: actions.SAVED_METER_CHANGING,
		});
	}, [changedMeters, houseId, activeMeterTypes, meterCode, dispatch]);

	const allValuesLessThanPrev = Object.values(changedMeters).filter(
		(changedMeter) => {
			return changedMeter?.valueIsLessThanPrev;
		}
	);
	const showConfirm = () => {
		confirm({
			title:
				"Вы действительно хотите сохранить показания, которые меньше предыдущих?",
			content: (
				<div>
					{allValuesLessThanPrev.map((changedMeter) => {
						return (
							<div>
								<p>Счётчик №{changedMeter.meterCode}</p>
								<div
									style={{
										border: "1px solid rgb(133, 133, 133)",
										borderRadius: "4px",
										padding: "5px",
										marginBottom: "10px",
									}}
								>
									<span
										style={{
											textDecoration: "line-through",
											marginRight: "5px",
										}}
									>
										{changedMeter.lastValue}
									</span>
									<span>{changedMeter.value}</span>
								</div>
							</div>
						);
					})}
				</div>
			),
			onOk() {
				saveChanges();
			},
		});
	};
	if (Object.values(changedMeters).filter(Boolean).length > 0) {
		return (
			<Button
				className={`save-changes `}
				type="submit"
				onClick={allValuesLessThanPrev.length === 0 ? saveChanges : showConfirm}
			>
				<Icon type="save" />
				Сохранить показания
			</Button>
		);
	} else return null;
};

const AddressMeters = ({}) => {
	const { itemLoading, meters, changedMeters } = useSelector(
		(store) => store.meterStore
	);
	const dispatch = useDispatch();
	const { id: houseId } = useParams();
	const [address, addressLoading] = useAddressFromParams(houseId);
	const activeMeterTypes = useParam("types", [], (arr) => arr?.map(Number));
	const activeTags = useParam("tags", [], (arr) => arr?.map(Number));
	const search = useParam("search", "");
	const meterCode = useMemo(() => {
		if (!isNaN(Number(search))) {
			return search;
		}
	}, [search]);
	useEffect(() => {
		dispatch(getAddressMeters(houseId, activeMeterTypes, meterCode, activeTags));
	}, [houseId, activeMeterTypes, meterCode, activeTags]);

	useEffect(() => {
		dispatch({ type: actions.SAVED_METER_CHANGING });
	}, [houseId, activeMeterTypes]);

	if (itemLoading || addressLoading) {
		return (
			<div className="meters-address-meters-spinning">
				<Spin
					style={{ minHeight: 500 }}
					size="large"
					spinning={itemLoading}
					tip="Загрузка..."
					delay={100}
				>
					<div></div>
				</Spin>
			</div>
		);
	}

	return (
		<>
			<div className="address_meters-header">
				<Row
					type="flex"
					justify="space-between"
					align="middle"
					className="header"
				>
					<span className="address">{address?.addressName || ''}</span>
					<SaveButton
						changedMeters={changedMeters}
						houseId={houseId}
						activeMeterTypes={activeMeterTypes}
						meterCode={meterCode}
						activeTags={activeTags}
					/>
					<Link to={`/Meters/newMeter/${houseId}`}>
						<Button className="add-button">Добавить ОДПУ</Button>
					</Link>
				</Row>
			</div>
			<div className="meters-address-meters-container">
				<div className="meters-address-meters">
					<Col type="flex" justify="start">
						{(activeMeterTypes?.length > 0 || activeTags?.length > 0) && (
							<Row type="flex" justify="start" className="filtration-row">
								<FiltrationTags />
							</Row>
						)}
						<Row>
							<div className="meters-address-content">
								{meters?.length > 0 &&
									meters.map((meter) => (
										<Meter key={meter.id} meter={meter} />
									))}
								{meters && !meters.length && (
									<Alert
										style={{ maxWidth: "500px", marginBottom: "10px" }}
										message="Счетчики не найдены"
										description="Попробуйте изменить условия поиска или фильтрации"
										type="info"
										showIcon
									/>
								)}
							</div>
						</Row>
					</Col>
				</div>
			</div>
		</>
	);
};

export default AddressMeters;
